@if (formGroup) {
  <app-input-control
    [fg]="formGroup"
    [formGroupOrControlName]="formGroupOrControlName"
    [label]="label"
    [placeholder]="placeholder"
    [enableUpload]="enableUpload"
    [accept]="accept"
    [multiple]="multiple"
    [directory]="directory"
    [mimeType]="mimeType"
    [enablePrevious]="enablePrevious"
    [autocomplete]="autocomplete"
    (showPrevious)="showPrevious.emit($event)"
    [disabled]="disabled"
    (onBlur)="onBlurEmitter.emit($event)"
  ></app-input-control>
}
